import { GlobalController } from 'src/shared/global/GlobalController'
import LegalSettlements from './LegalSettlements'
const ifAuthenticated = (to, from, next) => {
  GlobalController.getAsyncInstance().then(data => {
    if (data && data.authResp && data.authResp.token) {
      next()
    } else {
      next('/')
    }
  })
}
export const routes = [
  {
    path: 'finalcial/legal-settlements',
    name:
      'serviceRequest.financial.legal-settlements',
    component: LegalSettlements,
    beforeEnter: ifAuthenticated,
    props: true,
    meta: {
      fillContainer: true
    }
  }
]
